import { createStructuredSelector } from 'reselect'
import { branch, renderComponent, withHandlers } from 'recompose'
import classNames from 'classnames'

import { isMobile } from 'shared/responsive-helpers'
import { useSendGTAGEvent } from 'analytics/utils'
import { ACTIVE_FORM_LOGIN } from 'header/constants'
import { authVisible } from 'header/actions'
import { selectVehicle } from '@booking/actions'
import { userSelector } from 'auth/selectors'

import VehicleSelection from 'booking/components/BookingView/components/VehicleSelection'
import VehicleFormSection from './VehicleFormSection'
import LoginSignUpContainerMobile from './LoginSignUpContainerMobile'
import LoginSignUpContainerDesktop from './LoginSignUpContainerDesktop'

import styles from './styles.module.scss'

const $LoginSignUpContainerWrapped = ({ onClickLogin, onNext, setVehicle, selectVehicle }) => {
    const [showVehicleForm, setShowVehicleForm] = React.useState(false)

    const guestCheckoutBtnHandler = () => setShowVehicleForm(true)

    const loginSignUpComponent = isMobile() ? (
        <LoginSignUpContainerMobile onClickLogin={onClickLogin} guestCheckoutBtnHandler={guestCheckoutBtnHandler} />
    ) : (
        <LoginSignUpContainerDesktop onClickLogin={onClickLogin} guestCheckoutBtnHandler={guestCheckoutBtnHandler} />
    )

    return (
        <>
            {showVehicleForm && (
                <VehicleFormSection onNext={onNext} setVehicle={setVehicle} selectVehicle={selectVehicle} />
            )}
            {!showVehicleForm && loginSignUpComponent}
        </>
    )
}
const LoginSignUpContainerWrapped = compose(
    connect(null, { authVisible }),
    withHandlers({
        onClickLogin:
            ({ authVisible }) =>
            () => {
                authVisible(ACTIVE_FORM_LOGIN)
            },
    })
)($LoginSignUpContainerWrapped)

const GuestCheckoutVehicleSelection = compose(
    connect(createStructuredSelector({ user: userSelector }), { selectVehicle }),
    withTranslate,
    branch(({ user }) => !user, renderComponent(LoginSignUpContainerWrapped), renderComponent(VehicleSelection))
)(LoginSignUpContainerWrapped)

export default GuestCheckoutVehicleSelection
